import type { StyleMixin } from 'common/types/Styles';

// Use an outline with a negative offset rather than a border so that:
// 1. The button height is not impacted by the style (border would add to the height)
// 2. The outline is rendered inside the button, therefore not impacting the shadow's appearance
const buttonOutlineMixin: StyleMixin = ({ theme }) => `
  outline: 1px solid ${theme.variables.color.border.primary};
  outline-offset: -1px;
`;

export default buttonOutlineMixin;
